import React, { useState } from "react";
import tableup from "../../../../assets/tableup.svg";
import tabledown from "../../../../assets/tabledown.svg";
import { Accordion, Modal } from "react-bootstrap";
import CopyToClipboard from "react-copy-to-clipboard";
import moment from 'moment';
import ReactPaginate from "react-paginate";

const DataTable = ({ activityLogs, pagination, onPageChange }) => {
  console.log(pagination, 'paginationpagination');
  
  const renderPagination = () => {
    if (!pagination || pagination.totalPages <= 1) return null;

    const handlePageChange = (event) => {
      onPageChange(event.selected + 1); // ReactPaginate's page index is 0-based
    };

    return (
      <div className="footer-content">
           <div className="left-f">
              {/* <h6>SHOWING 1-10 OF 145</h6> */}
              {/* <h6>SHOWING 1-10 OF 145</h6> */}
            </div>
      <div className="right-f">
        <nav aria-label="Page navigation example">
          <ul className="pagination">
            <ReactPaginate
              previousLabel={
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M12.6665 8L3.33317 8" stroke="#042B33" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8 3.33329L3.33333 7.99996L8 12.6666" stroke="#042B33" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
              }
              nextLabel={
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M3.3335 8L12.6668 8" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8 3.33329L12.6667 7.99996L8 12.6666" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
              }
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              pageCount={pagination.totalPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName="pagination"
              activeClassName="active"
              forcePage={pagination.currentPage - 1} // ReactPaginate's page index is 0-based
            />
          </ul>
        </nav>
      </div>
      </div>
    );
  };
  return (
    <>
      <section className="datatable">
        <div className="tabled-noneformobile table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>
                  <div
                    className="parent-tag"
                    style={{ cursor: "pointer" }}
                  >
                    Date
                    <div className="filter-btn">
                      {/* <svg
                        width="9"
                        height="6"
                        viewBox="0 0 9 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.90908 5.14282H4.09498H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
                          fill="#77868B"
                        />
                      </svg>
                      <svg
                        width="9"
                        height="6"
                        viewBox="0 0 9 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.90908 0.857178H4.09498H0.660442C0.072714 0.857178 -0.22115 1.63778 0.195157 2.09537L3.36644 5.58114C3.87458 6.13967 4.70107 6.13967 5.20921 5.58114L6.41528 4.25547L8.38049 2.09537C8.79068 1.63778 8.49681 0.857178 7.90908 0.857178Z"
                          fill="#77868B"
                        />
                      </svg> */}
                    </div>
                  </div>
                </th>
                <th>
                  <div
                    className="parent-tag"
                    style={{ cursor: "pointer" }}
                  >
                    User
                  </div>
                </th>
                <th>
                  <div
                    className="parent-tag"
                    style={{ cursor: "pointer" }}
                  >
                    Activity
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {activityLogs &&
                activityLogs.map((log) => (
                  <tr key={log._id}>
                    <td>
                      <div className="twice-text">
                        <h6>{moment(log.createdAt).format("DD/MM/YYYY")}</h6>
                        <p>{moment(log.createdAt).format("H:mm")}</p>
                      </div>
                    </td>
                    <td>{log.adminName}</td>
                    <td>{log.activity}</td>
                  </tr>
                ))}
              {!activityLogs || activityLogs.length === 0 && (
                <tr>
                  <td colSpan="3">No activity logs found.</td>
                </tr>
              )}
            </tbody>
          </table>
          {renderPagination()}
        </div>
        <div className="accmblviewfdsasdf d-none">
          <div className="main-twice-text">
            <h6 className="accmblviewhead">Date</h6>
          </div>
          <Accordion>
            {activityLogs &&
              activityLogs.map((log) => (
                <Accordion.Item key={log._id}>
                  <Accordion.Header>
                    <div className="accheadermain">
                      <div className="twice-text">
                        <h6 style={{ color: "#000" }}>
                          {moment(log.createdAt).format("DD/MM/YYYY")}
                        </h6>
                        <p style={{ color: "#000" }}>
                          {moment(log.createdAt).format("H:mm")}
                        </p>
                      </div>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="acctexts">
                      <h6 className="textleft">User</h6>
                      <p className="textright">{log.adminName}</p>
                    </div>
                    <div className="acctexts">
                      <h6 className="textleft">Activity</h6>
                      <p
                        className="textright"
                        style={{ textAlign: "right" , fontSize : '10px' , lineHeight : '16px' , wordBreak : 'break-word' }}
                      >
                        {log.activity}
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            {!activityLogs || activityLogs.length === 0 && (
              <Accordion.Item>
                <Accordion.Header>No activity logs</Accordion.Header>
                <Accordion.Body>No activity logs found.</Accordion.Body>
              </Accordion.Item>
            )}
          </Accordion>
          {renderPagination()}
        </div>
      
      </section>
    
    </>
  );
};

export default DataTable;